import { StateIconWrapper } from './styles'
import { CheckOutlined } from '@ant-design/icons'

interface IProps {
  type: 'success' | 'fail'
}

const StateIcon = (props: IProps) =>
  <StateIconWrapper type={props.type}>
    <div>
      <div>
        {props.type === 'success' && <CheckOutlined />}
        {props.type === 'fail' && '!'}
      </div>
    </div>
  </StateIconWrapper>

export default StateIcon
